import { Endpoints } from '@/core/models/endpoints.interface';

interface InvoiceGroupEndpoints extends Pick<Endpoints, 'GET_ALL'> {
   CREATE: (companyId: number) => string;
   UPDATE: (companyId: number, invoiceGroupId: number) => string;
   ARCHIVE: (companyId: number, invoiceGroupId: number) => string;
   RESTORE_ARCHIVED: (companyId: number, invoiceGroupId: number) => string;
   DELETE: (companyId: number, invoiceGroupId: number) => string;
}

export const INVOICE_GROUP_ENDPOINTS: InvoiceGroupEndpoints = {
   GET_ALL: (companyId: number) => `/companies/${companyId}/invoice-groups`,
   CREATE: (companyId: number) => `/companies/${companyId}/invoice-groups`,
   UPDATE: (companyId: number, invoiceGroupId: number) => `/companies/${companyId}/invoice-groups/${invoiceGroupId}`,
   ARCHIVE: (companyId: number, invoiceGroupId: number) => `/companies/${companyId}/invoice-groups/${invoiceGroupId}`,
   RESTORE_ARCHIVED: (companyId: number, invoiceGroupId: number) => `/companies/${companyId}/invoice-groups/${invoiceGroupId}/restore`,
   DELETE: (companyId: number, invoiceGroupId: number) => `/companies/${companyId}/invoice-groups/${invoiceGroupId}/erase`,
};
